import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "171",
  height: "171",
  viewBox: "0 0 171 171",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#clip0_1209_32886)\"><path d=\"M171 0H0V170.991H171V0Z\" fill=\"var(--background-color, #4A70B3)\"></path><path d=\"M135.584 75.7165C133.73 77.5706 123.208 70.0507 112.074 58.9262C100.949 47.7922 93.4197 37.27 95.2832 35.4159C97.1373 33.5618 107.669 41.0817 118.793 52.2063C129.927 63.3308 137.438 73.8624 135.584 75.7165Z\" fill=\"#82BFE4\"></path><path d=\"M142.492 151.989L161.494 132.996L109.25 80.7518L132.996 37.9948L90.2479 61.7497L38.0039 9.49634L19.0018 28.4984L73.4858 82.9824L39.9521 125.448L23.7547 109.241L9.49609 123.49L27.3876 141.372L19.0018 151.989L29.6182 143.612L47.5003 161.494L61.7495 147.245L45.5427 131.038L88.008 97.514L142.492 151.989Z\" fill=\"#1B2247\"></path></g><defs><clipPath id=\"clip0_1209_32886\"><rect width=\"171\" height=\"170.991\" fill=\"white\"></rect></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }